/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DateString } from './dateString';
import { DateTime } from './dateTime';

export interface FileDescriptor { 
    entity_id: string;
    name: string;
    creator_account_id: string;
    content_type: string;
    size: number;
    state: FileDescriptor.StateEnum;
    public_url?: string;
    created: DateString;
    is_public: boolean;
    modified: DateString;
    age_in_folder?: Date;
}
export namespace FileDescriptor {
    export type StateEnum = 'pending' | 'valid' | 'deleted' | 'blocked';
    export const StateEnum = {
        Pending: 'pending' as StateEnum,
        Valid: 'valid' as StateEnum,
        Deleted: 'deleted' as StateEnum,
        Blocked: 'blocked' as StateEnum
    };
}